<template>
  <div class="dashboard-home">
    <!-- page heading -->
    <div class="dashboard-header">
      <div>
        <h2 class="dashboard-title">{{ projectName }} Dashboard</h2>
        <p class="dashboard-subtitle">Live project overview</p>
      </div>

      <div class="dashboard-updated">Last updated: {{ lastUpdated }}</div>
    </div>

    <!-- row 1: property stats + touch preview -->
    <div class="row mt-3">
      <div class="col-12 col-lg-5">
        <dashboard-property-stats @data-updated="updateTimestamp" />
      </div>

      <div class="col-12 col-lg-7">
        <dashboard-touch-preview
          :touch-url="touchUrl"
          @refreshed="updateTimestamp"
        />
      </div>
    </div>

    <!-- row 3: active pages + setup -->
    <div class="row mt-2">
      <!-- <div class="col-12 col-lg-4 dashboard-col">
        <dashboard-snitch-status />
      </div> -->
      <div class="col-12 col-lg-6 dashboard-col">
        <dashboard-active-pages />
      </div>
      <div class="col-12 col-lg-6">
        <dashboard-setup-checklist />
      </div>
    </div>

    <!-- row 2: nuc status -->
    <div class="row mt-4">
      <div class="col 12">
        <dashboard-snitch-status
          v-if="!$config.snitch || $config.snitch.enabled !== false"
        />
      </div>
    </div>

    <!-- demo: email properties + changelog + setup -->
    <!-- <div class="row mt-4">
      <div class="col-12 col-lg-4">
        <dashboard-changelog />
      </div>
      <div class="col-12 col-lg-4">
        <dashboard-email-log />
      </div>
    </div> -->

    <!-- webfeed debugger row -->
    <div class="row mt-4">
      <div class="col-12">
        <dashboard-webfeed-debugger
          v-if="$config.webfeedDebuggerWebsiteUrl"
          :client-url="$config.webfeedDebuggerWebsiteUrl"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DashboardPropertyStats from "@/components/Landing/DashboardPropertyStats.vue";
import DashboardTouchPreview from "@/components/Landing/DashboardTouchPreview.vue";
import DashboardSnitchStatus from "../components/Landing/DashboardSnitchStatus.vue";
import DashboardWebfeedDebugger from "../components/Landing/DashboardWebfeedDebugger.vue";
import DashboardActivePages from "../components/Landing/DashboardActivePages.vue";
import DashboardChangelog from "../components/Landing/DashboardChangelog.vue";
import DashboardEmailLog from "../components/Landing/DashboardEmailLog.vue";
import DashboardSetupChecklist from "../components/Landing/DashboardSetupChecklist.vue";

export default {
  name: "Dashboard",
  components: {
    DashboardPropertyStats,
    DashboardTouchPreview,
    DashboardSnitchStatus,
    DashboardWebfeedDebugger,
    DashboardActivePages,
    DashboardChangelog,
    DashboardEmailLog,
    DashboardSetupChecklist
  },

  data() {
    return {
      lastUpdatedAt: new Date()
    };
  },

  computed: {
    projectName() {
      return this.$config.projectName || "Project";
    },
    // use live touchscreen site
    touchUrl() {
      const host = process.env.VUE_APP_STAGING_HOST || "";
      return host.replace("://staging.", "://");
    },
    lastUpdated() {
      return this.lastUpdatedAt.toLocaleTimeString("en-AU", {
        hour: "2-digit",
        minute: "2-digit"
      });
    }
    // clientEmbedUrl() {
    //   return "https://skyridgeliving.com.au/land-for-sale#/masterplan/";
    // }
  },

  mounted() {
    // console.log(this.$config);
  },

  methods: {
    // to fix
    updateTimestamp() {
      this.lastUpdatedAt = new Date();
    }
  }
};
</script>

<style scoped>
.dashboard-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 18px;
}

.dashboard-title {
  font-size: 22px;
  font-weight: 600;
  margin: 0;
}

.dashboard-subtitle {
  font-size: 13px;
  color: #6b7280;
  margin: 2px 0 0;
}

.dashboard-updated {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}

/* .dashboard-col :deep(.dashboard-card) {
  height: 620px;
} */
</style>

<style lang="scss">
.dashboard-card .card-header h4 {
  margin: 0;
}

/* Dashboard button theme (scoped + higher specificity) */
.dashboard-home .btn.btn-sr {
  border-radius: 8px;
  font-weight: 600;
  letter-spacing: 0.2px;
  padding: 8px 14px;
  line-height: 1.1;
  border: 1px solid transparent;
  background: transparent;
  transition: background-color 160ms ease, border-color 160ms ease,
    box-shadow 160ms ease, color 160ms ease;
}

/* Secondary (utility): Refresh */
.dashboard-home .btn.btn-sr.btn-sr--secondary {
  background: #fff;
  border-color: #d1d5db;
  color: #111827;
}

.dashboard-home .btn.btn-sr.btn-sr--secondary:hover {
  background: #f9fafb;
  border-color: #9ca3af;
}

/* Primary (action): Open Touch */
.dashboard-home .btn.btn-sr.btn-sr--primary {
  background: #26c281;
  border-color: #26c281;
  color: #fff;
}

.dashboard-home .btn.btn-sr.btn-sr--primary:hover {
  background: #22af74;
  border-color: #22af74;
  box-shadow: 0 0 0 3px rgba(38, 194, 129, 0.18);
}

.dashboard-home .btn.btn-sr:disabled,
.dashboard-home .btn.btn-sr[disabled] {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none !important;
}
</style>
